import { pluralizeRu } from '@shared/lib/formatFile';

/* Числа словами для списков «Заявок на оплату». */

export const requestsCount = (n: number) =>
  `${n} ${pluralizeRu(n, ['заявка', 'заявки', 'заявок'])}`;

/** «оплачено 23 дня назад». */
export function daysAgo(n: number | null | undefined): string {
  if (n == null) return '';
  if (n <= 0) return 'сегодня';
  if (n === 1) return 'вчера';
  return `${n} ${pluralizeRu(n, ['день', 'дня', 'дней'])} назад`;
}

export const remindersCount = (n: number) =>
  n === 0
    ? 'ещё не напоминали'
    : `${n} ${pluralizeRu(n, ['напоминание', 'напоминания', 'напоминаний'])}`;
